import styled from 'styled-components/macro'
import { Button } from '../../../../../../../shared/components/button/Button'

export const PersonalDetailsFormContainer = styled.div`
  width: 100%;
`

export const ButtonWrapper = styled(Button)`
  font-weight: 500;
  font-size: 16px;
  line-height: 9px;
  letter-spacing: -0.075em;
  margin-bottom: 75px;
  background: #c00000;
  color: #fff;
  padding: 20px 0;
  border: none;
  cursor: pointer;

  &.disabled {
    background: rgba(192, 0, 0, 0.5);
  }
`
